angular.module('Itao.IndicatorMap').directive('scatterPlot', function (d3, mapConfig) {
  'use strict';

  var xValue = d3.hyperion.accessor('x');
  var yValue = d3.hyperion.accessor('y');
  var keyValue = d3.hyperion.accessor('key');
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var color = d3.hyperion.indicatorColorAt;

  var combineDataAndIndicators = function(data, indicatorX, indicatorY, selectedDistricts) {
    var dataArray = [];
    var selectedUids = selectedDistricts.map(function(district){
      return district.uid;
    });
    for(var districtUid in data.districts) {
      if(data[districtUid].hasOwnProperty(indicatorX.uid) && data[districtUid][indicatorX.uid] != null && data[districtUid].hasOwnProperty(indicatorY.uid) && data[districtUid][indicatorY.uid] != null) {
        var selected = selectedUids.indexOf(districtUid) !== -1;
        dataArray.push({uid: districtUid, key: data.districts[districtUid].key, name: data.districts[districtUid].name, x: data[districtUid][indicatorX.uid], y: data[districtUid][indicatorY.uid], selected: selected});
      }
    }
    return dataArray;
  };

  var uniqueDataDotsForVoronoi = function(a) {
    var seen = {};
    return a.filter(function(item) {
      var itemString = (item.x +'-'+ item.y).replace('.', '_');
      return seen.hasOwnProperty(itemString) ? false : (seen[itemString] = item);
    });
  };

  /**
   * returns a function to apply values depending on the 'selected' property
   *
   * @param selectdValue
   * @param unselectedValue
   * @returns {Function}
   */
  function valueDependingOnSelected(selectdValue, unselectedValue) {
    return function(d) {
      return d.selected ? selectdValue : unselectedValue;
    };
  }

  var scatterPlot = function() {

    var indicatorX = null,
      indicatorY = null,
      selectedDistricts = [],
      margin = {top: 20, right: 40, bottom: 40, left: 60},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function(selection) {
      selection.each(function(unformattedData) {
        if(indicatorX == null || indicatorY == null) {
          d3.select(this).selectAll('svg').remove();
          d3.select(this).selectAll('p').remove();
          d3.select(this).append('p').text('Es müssen mindestens zwei Indikatoren ausgewählt sein.');
          return;
        } else {
          d3.select(this).selectAll('p').remove();
        }
        var data = combineDataAndIndicators(unformattedData, indicatorX, indicatorY, selectedDistricts);

        var container = d3.select(this).datum([data]).classed('scatter-plot', true);

        var svgWidth = selection.node().offsetWidth - 10,
          svgHeight = selection.node().offsetHeight - 10; // add 10px space for preventing scrollbars

        var yExtent = d3.extent(data, yValue);

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max(germanNumberFormat(',')(Math.round(yExtent[0])).length, germanNumberFormat(',')(Math.round(yExtent[1])).length);
        margin.left = 45 + 10 * labelDigits;

        var width = svgWidth - margin.left -margin.right,
          height = svgHeight - margin.top - margin.bottom;

        var svg = container.selectAll('svg').data([data]);

        svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var x = d3.scale.linear()
          .range([0, width])
          .domain(d3.extent(data, xValue))
          .nice();

        var y = d3.scale.linear()
          .range([height, 0])
          .domain(yExtent)
          .nice();

        var xAxis = d3.svg.axis()
          .scale(x)
          .orient('bottom')
          .ticks(Math.min(svgWidth / 90, 10))
          .tickFormat(germanNumberFormat(','));

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(Math.min(svgHeight / 40, 10))
          .tickFormat(germanNumberFormat(','));

        if(angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function(){
            return [-5, 0];
          })
          .html(function(d){
            var x, y;
            if(indicatorX.unit) {
              x = numberFormat(d.x);
            } else {
              x = d.x;
            }
            if(indicatorY.unit) {
              y = numberFormat(d.y);
            } else {
              y = d.y;
            }
            return '<div class="d3-tip-border"><b>'+d.name+' ('+d.key+')</b><br/>'
              +'<span style="color:'+color(0)+'">'+indicatorX.name+':</span> <span>'+x+indicatorX.unit+'</span><br/>'
              +'<span  style="color:'+color(1)+'">'+indicatorY.name+':</span> <span>'+y+indicatorY.unit+'</span></div>';
          });

        // add x axis
        gEnter.append('g')
          .classed('x axis', true)
          .attr('transform', 'translate(0,' + height + ')')
          .append('text')
          .classed('x label', true)
          .attr('fill', color(0))
          .attr('x', width/2)
          .attr('dy', '2.6em')
          .style('text-anchor', 'middle');

        // update x axis label
        g.select('.x.label')
          .text(indicatorX.name)
          .transition().duration(duration)
          .attr('x', width/2);

        //update x axis
        g.select('.x.axis')
          .transition().duration(duration)
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis);

        // add y axis
        gEnter.append('g')
          .classed('y axis', true)
          .attr('y', height)
          .append('text')
          .classed('y label', true)
          .attr('fill', color(1))
          .attr('transform', 'rotate(-90)')
          .attr('x', -height/2)
          .attr('dy', '-' + (margin.left - 15))
          .style('text-anchor', 'middle');

        // update y axis label
        g.select('.y.label')
          .text(indicatorY.name)
          .transition().duration(duration)
          .attr('dy', '-' + (margin.left - 15))
          .attr('x', -height/2);

        // update y axis
        g.select('.y.axis')
          .transition().duration(duration)
          .attr('y', height)
          .call(yAxis);

        // create dots selection
        var dots = g.selectAll('.feature')
          .data(data, keyValue);

        // add new dots
        dots.enter()
          .append('circle')
          .attr('class', function(d){
            return 'feature uid-'+ d.uid;
          });

        // update dots position
        dots.transition().duration(duration)
          .attr('r', valueDependingOnSelected(3, 2))
          .attr('cx', compose(x, xValue))
          .attr('cy', compose(y, yValue))
          .attr('stroke', 'black')
          .attr('fill', valueDependingOnSelected('#f29400', 'black'))
          .attr('stroke-width', valueDependingOnSelected('1px', '0px'));

        dots.call(tip);

        // voronoi calculator
        var voronoi = d3.geom.voronoi()
          .x(compose(x, xValue))
          .y(compose(y, yValue))
          .clipExtent([[0, 0], [width, height]]);

        // voronoi used for showing the tooltip of the point closest to the cursor
        // points with the same values have to be filtered, because a voronoi cannot be computed for duplicates
        var voronoiPolygons = g.selectAll('.voronoi')
          .data(voronoi(uniqueDataDotsForVoronoi(data)));

        // add voronoi pahts and register mouseEvents for tooltips
        voronoiPolygons.enter()
          .append('path')
          .style('fill', 'none')
          .style('pointer-events', 'all')
          .attr('class', 'voronoi')
          .on('mouseover', function(d) {
            var dot = g.select('.uid-'+d.point.uid);
            tip.show(d.point, dot.node());
          })
          .on('mouseout', function(d){
            tip.hide(d.point);
          });

        // update voronoi paths
        voronoiPolygons
          .attr('d', function(d) {
            return 'M' + d.join('L') + 'Z';
          });

        // delete unused voronoi paths
        voronoiPolygons.exit().remove();

        // remove old dots
        dots.exit().remove();
      });
    };

    /**
     * getter/setter for x-indicator
     * @param {Array} [newIndicatorX] new indicator for x scale
     * @returns {*}
     */
    chart.indicatorX = function(newIndicatorX) {
      if(!arguments.length) {
        return indicatorX;
      } else {
        indicatorX = newIndicatorX;
        return chart;
      }
    };

    /**
     * getter/setter for y-indicator
     * @param {Array} [newIndicatorY] new indicator for y scale
     * @returns {*}
     */
    chart.indicatorY = function(newIndicatorY) {
      if(!arguments.length) {
        return indicatorY;
      } else {
        indicatorY = newIndicatorY;
        return chart;
      }
    };

    /**
     * getter/setter for selected districts
     * @param {Array} [newSelectedDistricts] selected districts
     * @returns {*}
     */
    chart.selectedDistricts = function(newSelectedDistricts) {
      if(!arguments.length) {
        return selectedDistricts;
      } else {
        selectedDistricts = newSelectedDistricts;
        return chart;
      }
    };

    /**
     * getter for the tooltip
     *
     * @returns {*}
     */
    chart.tip = function() {
      return tip;
    };

    return chart;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'scatterPlot.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.fullscreen = scope.config.fullscreen || false;
      var scatterPlotFunction = scatterPlot();

      var rerender = function() {
        var indicators = scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
        });
        scatterPlotFunction
          .selectedDistricts(scope.selectedDistricts)
          .indicatorX(indicators[0] || null)
          .indicatorY(indicators[1] || null);

        d3.select(element.find('.widget-inner:first')[0])
          .data([scope.layer])
          .call(scatterPlotFunction);
      };

      var layerWatcher = scope.$watch('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      // remove watcher on destroy
      element.on('$destroy', function() {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        // remove tooltip dom element
        if(angular.isDefined(scatterPlotFunction.tip())) {
          scatterPlotFunction.tip().destroy();
        }
      });
    }
  };
});
